import React from 'react';
import { BlockWrapper } from './BlockWrapper';
import { buildProfileBlocks } from '../util';
import { ISummaryData } from '../../../types';
import { useStore } from '../../../store';

export const BlockListWrapper = () => {
  const summaryData: ISummaryData = useStore((state) => state.summary);

  return (
    <div
      id='profileToggleContent'
      className='absolute bottom-0 translate-y-[calc(100%-5px)] left-0 bg-bw00 rounded-b-[8px] w-full cursor-pointer shadow-light'
    >
      {buildProfileBlocks(summaryData).map((item) => (
        <BlockWrapper shouldHide={!item.isShown} shouldAvoidPadding={item.shouldAvoidWrapperPadding} key={item.id}>
          <div>{item.component()}</div>
        </BlockWrapper>
      ))}
    </div>
  );
};
